export enum SECTIONS {
	MAIN = 'main',
	INFO = 'info',
	SUCCESS = 'success',
	ERRORS = 'errors',
	ACCOUNT = 'account',
	CHECK = 'check',
	APPLY = 'apply',
	PROCESS = 'process',
	DIRECTOR = 'director',
	PASSWORD = 'password',
}

export enum INIVATE_TYPE {
	NEW = 'new',
	REPEAT = 'repeat',
}
